
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30350',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30350",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54683",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8051",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11509",
  "I18n": "static-7-hdineen_hubspot-i18n-react-compiler.2",
  "quartz": "static-1.7078",
  "quartz-config": "static-1.856",
  "quartz-core": "static-1.6297",
  "react-dlb": "static-1.79",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.799",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54670",
  "feedback-utils": "static-1.54674",
  "forms-embed-utils-lib": "static-1.4500",
  "forms-utils-lib": "static-1.12654",
  "foundations-assets": "static-1.4905",
  "foundations-components": "static-1.8004",
  "foundations-theming": "static-1.4456",
  "hub-http": "static-1.6259",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11816",
  "icons": "static-2.650",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3945",
  "raven": "static-3.5925",
  "react": "static-7.186",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16711",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5372",
  "react-virtualized": "static-2.99",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.488",
  "tinymce-plugins": "static-1.57600",
  "transmute": "static-2.85",
  "ui-images": "static-2.1161",
  "UIComponents": "static-3.8455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3427",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3355",
  "quartz-webpack": "static-1.3302",
  "foundations-theming-specialty": "static-1.2172",
  "property-description-translator": "static-1.3879",
  "HeadJS": "static-2.765",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3162",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4363",
  "jasmine-runner": "static-1.6500",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4679",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.753",
  "quartz-head": "static-1.743",
  "quartz-i18n": "static-1.753",
  "quartz-routing": "static-1.508",
  "quartz-test": "static-1.753",
  "quartz-tracking": "static-1.457",
  "ui-fonts": "static-1.771",
  "usage-tracker-container": "static-1-cwunder-lower-max-network-payload-size.10",
  "usage-tracker-core": "static-1-cwunder-lower-max-network-payload-size.10",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.156",
  "conversations-skeleton-state": "static-1.7284",
  "reference-resolvers": "static-1.8208",
  "sanitize-text": "static-1.8179",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10402",
  "sanitize": "static-1.4512",
  "outpost": "static-1.4215",
  "rpc-client-utils": "static-1.4689",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4273",
  "floating-ui": "static-1.56",
  "hs-story-utils": "static-1.9460",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.30",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2044",
  "bend-plugin-foundations-theming": "static-1.2939",
  "foundations-theming-base": "static-1.3441",
  "stylex": "static-1.33",
  "hs-locale-management": "static-1.109",
  "csstype": "static-1.50",
  "web-vitals": "static-1.6",
  "ai-components-ui-library": "static-1.9069",
  "atom": "static-1.5110",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7807",
  "ContentUtils": "static-1.68486",
  "data-token-picker": "static-1.16470",
  "file-manager-components": "static-1.23729",
  "FileManagerCore": "static-1.39228",
  "FileManagerLib": "static-1.39369",
  "frontend-preferences-client": "static-1.7964",
  "hub-http-contrib": "static-1.3078",
  "interframe": "static-3.4796",
  "layout-dnd-components": "static-1.12513",
  "layout-dnd-utils": "static-1.11488",
  "property-translator": "static-1.5435",
  "react-codemirror": "static-1.10663",
  "react-colorpicker": "static-2.10244",
  "reference-resolvers-lite": "static-1.8132",
  "rich-text-lib": "static-1.19896",
  "tinymce-data": "static-1.40571",
  "tinymce-themes": "static-1.56456",
  "ui-addon-emoji-picker": "static-1.9924",
  "ui-addon-sales-email": "static-1.5247",
  "ui-brand-identity-lib": "static-1.15444",
  "bender-build-tools": "static-1.3227",
  "hub-http-shared-msw-handlers": "static-1.10057",
  "hubspotter-http-shared-msw-handlers": "static-1.10055",
  "usage-tracker-session-replay": "static-1-cwunder-lower-max-network-payload-size.10",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.99",
  "chirp-fetch": "static-1.1924",
  "chatspot-core": "static-1.21456",
  "copilot-toolkit": "static-1.11234",
  "customer-data-objects-ui-components": "static-1.13066",
  "data-fetching-client": "static-1.9703",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4797",
  "ui-addon-video-player": "static-1.8739",
  "ui-coaching-tips": "static-1.28676",
  "usage-tracker": "static-1-cwunder-lower-max-network-payload-size.10",
  "cms-field-types": "static-1.4849",
  "content-icons-ui": "static-1.2234",
  "integrations-lib": "static-1.16300",
  "customer-data-objects": "static-1.7711",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4688",
  "apollo-stack-hubspot": "static-3.86",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "immerable": "static-1.4190",
  "ui-addon-iframeable": "static-1.9097",
  "video-components-external": "static-1.11427",
  "video-data-lib": "static-1.35085",
  "audio-components": "static-1.5969",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29365",
  "FileManagerImages": "static-1.36880",
  "foundations-components-legacy": "static-1.1029",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.525",
  "ui-universal-auth": "static-1.9021",
  "urlinator": "static-1.4573",
  "video-components": "static-1.13429",
  "video-embed": "static-1.35919",
  "ts-schema": "static-1.4108",
  "ContentData": "static-1.68561",
  "layout-data-lib": "static-1.9813",
  "react-dnd-compat": "static-1.4651",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1578",
  "external-options-client-types": "static-1.4188",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6922",
  "hs-promise-utils": "static-1.5627",
  "inbound-db-properties-service-client": "static-1.3874",
  "NamespacedHubStyle": "static-2.9087",
  "growth-onboarding-confetti": "static-1.3103",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11185",
  "amplitude-session-replay-browser": "static-1.61",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.770",
  "magpie-lib": "static-1.5575",
  "magpie-types": "static-1.5035",
  "simple-logging-lib": "static-1.3087",
  "avatar-components": "static-1.2535",
  "customer-data-ui-utilities": "static-1.9862",
  "growth-onboarding-feedback-components": "static-1.6616",
  "flux-actions": "static-1.341",
  "hubspot-apollo-client": "static-1.4915",
  "integrations-error-boundary-lib": "static-1.13715",
  "integrations-tracking-lib": "static-1.5639",
  "laboratory-lib": "static-3.7192",
  "native-integrations-shared-strings": "static-1.7818",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10221",
  "unified-auth": "static-1.535",
  "navigation-messaging": "static-1.7463",
  "content-media-composition-data-lib": "static-1.12468",
  "content-media-compositions": "static-2.16475",
  "idb-keyval": "static-1.44",
  "media-bridge-lib": "static-1.18989",
  "unified-auth-core-lib": "static-1.817",
  "social-insights-client-types": "static-1.22222",
  "advanced-menus-core": "static-1.15184",
  "advanced-menus-lib": "static-1.12122",
  "ExportDialog": "static-6.10421",
  "ui-memberships-settings-lib": "static-1.34161",
  "conditional-properties-service-client": "static-1.3826",
  "crm-pipelines-api-client-types": "static-1.4168",
  "fdsr-migration-layer": "static-1.41",
  "framework-builder-read-service-client": "static-1.4033",
  "framework-data-schema-quick-fetch": "static-1.6827",
  "inbound-db-meta-service-client": "static-1.3614",
  "multi-currency-client-types": "static-1.3720",
  "persist-promise": "static-1.3735",
  "foundations-components-test-utils": "static-1.5487",
  "ably": "static-2.2",
  "highlight.js": "static-1.79",
  "reactive-lib": "static-1.759",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.374",
  "universal-page-editor-lib": "static-1.3050",
  "google-sheets-integration-lib": "static-1.360",
  "microsoft-drive-integration-lib": "static-1.487",
  "slack-ui-library": "static-1.10429",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3768",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15183",
  "simple-menus-lib": "static-1.16700",
  "crm-record-cards-service-types": "static-1.3617",
  "location-customization-utils-lib": "static-1.9383",
  "react-flip-move": "static-1.70"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30350",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54683",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8051",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11509",
  "I18n": "/I18n/static-7-hdineen_hubspot-i18n-react-compiler.2",
  "quartz": "/quartz/static-1.7078",
  "quartz-config": "/quartz-config/static-1.856",
  "quartz-core": "/quartz-core/static-1.6297",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.799",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54670",
  "feedback-utils": "/feedback-utils/static-1.54674",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4500",
  "forms-utils-lib": "/forms-utils-lib/static-1.12654",
  "foundations-assets": "/foundations-assets/static-1.4905",
  "foundations-components": "/foundations-components/static-1.8004",
  "foundations-theming": "/foundations-theming/static-1.4456",
  "hub-http": "/hub-http/static-1.6259",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11816",
  "icons": "/icons/static-2.650",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3945",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.186",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16711",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5372",
  "react-virtualized": "/react-virtualized/static-2.99",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tinymce-plugins": "/tinymce-plugins/static-1.57600",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1161",
  "UIComponents": "/UIComponents/static-3.8455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3427",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3355",
  "quartz-webpack": "/quartz-webpack/static-1.3302",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2172",
  "property-description-translator": "/property-description-translator/static-1.3879",
  "HeadJS": "/HeadJS/static-2.765",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3162",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4363",
  "jasmine-runner": "/jasmine-runner/static-1.6500",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4679",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.753",
  "quartz-head": "/quartz-head/static-1.743",
  "quartz-i18n": "/quartz-i18n/static-1.753",
  "quartz-routing": "/quartz-routing/static-1.508",
  "quartz-test": "/quartz-test/static-1.753",
  "quartz-tracking": "/quartz-tracking/static-1.457",
  "ui-fonts": "/ui-fonts/static-1.771",
  "usage-tracker-container": "/usage-tracker-container/static-1-cwunder-lower-max-network-payload-size.10",
  "usage-tracker-core": "/usage-tracker-core/static-1-cwunder-lower-max-network-payload-size.10",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.156",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7284",
  "reference-resolvers": "/reference-resolvers/static-1.8208",
  "sanitize-text": "/sanitize-text/static-1.8179",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10402",
  "sanitize": "/sanitize/static-1.4512",
  "outpost": "/outpost/static-1.4215",
  "rpc-client-utils": "/rpc-client-utils/static-1.4689",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4273",
  "floating-ui": "/floating-ui/static-1.56",
  "hs-story-utils": "/hs-story-utils/static-1.9460",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.30",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2044",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2939",
  "foundations-theming-base": "/foundations-theming-base/static-1.3441",
  "stylex": "/stylex/static-1.33",
  "hs-locale-management": "/hs-locale-management/static-1.109",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.6",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9069",
  "atom": "/atom/static-1.5110",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7807",
  "ContentUtils": "/ContentUtils/static-1.68486",
  "data-token-picker": "/data-token-picker/static-1.16470",
  "file-manager-components": "/file-manager-components/static-1.23729",
  "FileManagerCore": "/FileManagerCore/static-1.39228",
  "FileManagerLib": "/FileManagerLib/static-1.39369",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7964",
  "hub-http-contrib": "/hub-http-contrib/static-1.3078",
  "interframe": "/interframe/static-3.4796",
  "layout-dnd-components": "/layout-dnd-components/static-1.12513",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11488",
  "property-translator": "/property-translator/static-1.5435",
  "react-codemirror": "/react-codemirror/static-1.10663",
  "react-colorpicker": "/react-colorpicker/static-2.10244",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8132",
  "rich-text-lib": "/rich-text-lib/static-1.19896",
  "tinymce-data": "/tinymce-data/static-1.40571",
  "tinymce-themes": "/tinymce-themes/static-1.56456",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9924",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5247",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15444",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10057",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10055",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-cwunder-lower-max-network-payload-size.10",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.99",
  "chirp-fetch": "/chirp-fetch/static-1.1924",
  "chatspot-core": "/chatspot-core/static-1.21456",
  "copilot-toolkit": "/copilot-toolkit/static-1.11234",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13066",
  "data-fetching-client": "/data-fetching-client/static-1.9703",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4797",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8739",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28676",
  "usage-tracker": "/usage-tracker/static-1-cwunder-lower-max-network-payload-size.10",
  "cms-field-types": "/cms-field-types/static-1.4849",
  "content-icons-ui": "/content-icons-ui/static-1.2234",
  "integrations-lib": "/integrations-lib/static-1.16300",
  "customer-data-objects": "/customer-data-objects/static-1.7711",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4688",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4190",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9097",
  "video-components-external": "/video-components-external/static-1.11427",
  "video-data-lib": "/video-data-lib/static-1.35085",
  "audio-components": "/audio-components/static-1.5969",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29365",
  "FileManagerImages": "/FileManagerImages/static-1.36880",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1029",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.525",
  "ui-universal-auth": "/ui-universal-auth/static-1.9021",
  "urlinator": "/urlinator/static-1.4573",
  "video-components": "/video-components/static-1.13429",
  "video-embed": "/video-embed/static-1.35919",
  "ts-schema": "/ts-schema/static-1.4108",
  "ContentData": "/ContentData/static-1.68561",
  "layout-data-lib": "/layout-data-lib/static-1.9813",
  "react-dnd-compat": "/react-dnd-compat/static-1.4651",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1578",
  "external-options-client-types": "/external-options-client-types/static-1.4188",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6922",
  "hs-promise-utils": "/hs-promise-utils/static-1.5627",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3874",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9087",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3103",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11185",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.61",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.770",
  "magpie-lib": "/magpie-lib/static-1.5575",
  "magpie-types": "/magpie-types/static-1.5035",
  "simple-logging-lib": "/simple-logging-lib/static-1.3087",
  "avatar-components": "/avatar-components/static-1.2535",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9862",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6616",
  "flux-actions": "/flux-actions/static-1.341",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4915",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13715",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5639",
  "laboratory-lib": "/laboratory-lib/static-3.7192",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7818",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10221",
  "unified-auth": "/unified-auth/static-1.535",
  "navigation-messaging": "/navigation-messaging/static-1.7463",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12468",
  "content-media-compositions": "/content-media-compositions/static-2.16475",
  "idb-keyval": "/idb-keyval/static-1.44",
  "media-bridge-lib": "/media-bridge-lib/static-1.18989",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.817",
  "social-insights-client-types": "/social-insights-client-types/static-1.22222",
  "advanced-menus-core": "/advanced-menus-core/static-1.15184",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12122",
  "ExportDialog": "/ExportDialog/static-6.10421",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34161",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3826",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4168",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.41",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4033",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6827",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3614",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3720",
  "persist-promise": "/persist-promise/static-1.3735",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5487",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.79",
  "reactive-lib": "/reactive-lib/static-1.759",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.374",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3050",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.360",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.487",
  "slack-ui-library": "/slack-ui-library/static-1.10429",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3768",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15183",
  "simple-menus-lib": "/simple-menus-lib/static-1.16700",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3617",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9383",
  "react-flip-move": "/react-flip-move/static-1.70"
}
};
